import Service from "./service";
import StockSuppliers from "./stock-supplier";

export default class extends Service {
  constructor() {
    super(...arguments);
    this.setEndPoint("stock");
  }
}
